import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatusIconComponent } from './status-icon.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    StatusIconComponent
  ],
  exports: [StatusIconComponent],
})
export class StatusIconModule { }
